import { IActivePass, IPassGroup } from '../../models'
import {
  IBuyPassAction,
  IBuyPassFailedAction,
  IBuyPassSuccessfulAction,
  IFetchActivePassesAction,
  IFetchActivePassesSuccessfulAction,
  IFetchAvailablePassesAction,
  IFetchAvailablePassesSuccessfulAction,
  ISetBuyPassConfirmingAction,
  ISetBuyPassPollingAction,
  ISetIsBuyingPassAction,
  ISetIsFetchingActivePassesAction,
  ISetIsFetchingAvailablePassesAction,
  WalletTypeKeys
} from '../types'

export function fetchActivePassesAction(): IFetchActivePassesAction {
  return { type: WalletTypeKeys.FETCH_ACTIVE_PASSES }
}

export function setIsFetchingActivePassesAction(): ISetIsFetchingActivePassesAction {
  return { type: WalletTypeKeys.FETCHING_ACTIVE_PASSES }
}

export function fetchActivePassesSuccessfulAction(passes: IActivePass[]): IFetchActivePassesSuccessfulAction {
  return { type: WalletTypeKeys.FETCH_ACTIVE_PASSES_SUCCESSFUL, payload: passes }
}

export function fetchAvailablePassesAction(): IFetchAvailablePassesAction {
  return { type: WalletTypeKeys.FETCH_AVAILABLE_PASSES }
}

export function setIsFetchingAvailablePassesAction(): ISetIsFetchingAvailablePassesAction {
  return { type: WalletTypeKeys.FETCHING_AVAILABLE_PASSES }
}

export function fetchAvailablePassesSuccessfulAction(passes: IPassGroup[]): IFetchAvailablePassesSuccessfulAction {
  return { type: WalletTypeKeys.FETCH_AVAILABLE_PASSES_SUCCESSFUL, payload: passes }
}

export function buyPassAction(passId: number, accountId: string): IBuyPassAction {
  return { type: WalletTypeKeys.BUY_PASS, payload: { passId, accountId } }
}

export function setIsBuyingPassAction(): ISetIsBuyingPassAction {
  return { type: WalletTypeKeys.BUYING_PASS }
}

export function setBuyPassConfirmingAction(): ISetBuyPassConfirmingAction {
  return { type: WalletTypeKeys.BUY_PASS_CONFIRMING }
}

export function setBuyPassPollingAction(): ISetBuyPassPollingAction {
  return { type: WalletTypeKeys.BUY_PASS_POLLING }
}

export function buyPassSuccessfulAction(): IBuyPassSuccessfulAction {
  return { type: WalletTypeKeys.BUY_PASS_SUCCESSFUL }
}

export function buyPassFailedAction(): IBuyPassFailedAction {
  return { type: WalletTypeKeys.BUY_PASS_FAILED }
}
